import { useEffect } from "react";
import { motion, useScroll } from "framer-motion";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Stats from "../components/Stats";
import ManifestoMarquee from "../components/Marquee";
import Services from "../components/Services";
import BeforeAfter from "../components/BeforeAfter";
import Process from "../components/Process";
import WhyChoose from "../components/WhyChoose";
import Reviews from "../components/Reviews";
import Projects from "../components/Projects";
import Areas from "../components/Areas";
import Faq from "../components/Faq";
import FinalCta from "../components/FinalCta";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import FloatingActions from "../components/FloatingActions";

export default function Home() {
  const { scrollYProgress } = useScroll();
  useEffect(() => {
    document.title = "Sterling Roofworks | Premium Roofers in Stockport, Manchester & Cheshire";
  }, []);

  return (
    <>
      <motion.div style={{ scaleX: scrollYProgress }} data-testid="scroll-progress"
        className="fixed top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-[#AA8922] via-[#E5C869] to-[#D4AF37] origin-left z-[85]" />
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <ManifestoMarquee />
        <Services />
        <BeforeAfter />
        <Process />
        <WhyChoose />
        <Reviews />
        <Projects />
        <Areas />
        <Faq />
        <FinalCta />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />
    </>
  );
}
